var path = 'rulechain/rulenode-config.tpl.html';
var html = "\n\n<tb-rule-node-defined-config ng-if=\"useDefinedDirective()\" rule-node-id=\"ruleNodeId\" ng-model=\"configuration\" rule-node-directive=\"{{nodeDefinition.configDirective}}\" ng-required=\"required\" ng-readonly=\"readonly\">\n</tb-rule-node-defined-config>\n<div class=\"tb-rulenode-directive-error\" ng-if=\"definedDirectiveError\">{{definedDirectiveError}}</div>\n<tb-json-object-edit ng-if=\"!useDefinedDirective()\" class=\"tb-rule-node-configuration-json\" ng-model=\"configuration\" label=\"{{ 'rulenode.configuration' | translate }}\" ng-required=\"required\" fill-height=\"true\">\n</tb-json-object-edit>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/rulechain/rulenode-config.tpl.html
// module id = 1516
// module chunks = 1